<template>
  <!-- Тёмная карточка поддержки в шторке профиля (handoff p1, p2; вариант C) -->
  <article class="tech-support">
    <div class="tech-support__head">
      <v-icon size="22" class="tech-support__icon">
        mdi-message-text-outline
      </v-icon>
      <div>
        <div class="tech-support__title">
          ТЕХНИЧЕСКАЯ ПОДДЕРЖКА
        </div>
        <!-- Часы из графика поддержки (/me); сервис не ответил - строки нет -->
        <div v-if="hours" class="tech-support__hours">
          Поддержка работает {{ hours }}
        </div>
      </div>
    </div>

    <button type="button" class="tech-support__appeals" @click="openAppeals">
      <span class="tech-support__appeals-label">Обращения филиала</span>
      <!-- Непрочитанные ответы по обращениям филиала; гаснет, когда обращение открыто (p3a) -->
      <span v-if="unread > 0" class="tech-support__badge">{{ unreadText }}</span>
      <v-icon size="18" class="tech-support__chevron">
        mdi-chevron-right
      </v-icon>
    </button>

    <v-btn
      depressed
      block
      height="40"
      class="tech-support__write text-normalize"
      @click="writeToSupport"
    >
      <v-icon left size="16">
        mdi-pencil
      </v-icon>
      Написать в поддержку
    </v-btn>
  </article>
</template>

<script>
  import { mapGetters } from 'vuex'
  import RouteName from '@/models/enums/RouteName'
  import { newCount, scheduleText } from '@/components/support/format'

  export default {
    name: 'TechSupportCard',
    computed: {
      ...mapGetters({
        schedule: 'support/schedule',
        unread: 'support/appealsUnread',
      }),
      hours () {
        return scheduleText(this.schedule)
      },
      unreadText () {
        return newCount(this.unread)
      },
    },
    methods: {
      openAppeals () {
        this.$store.commit('app/hideProfileDrawer')
        if (this.$route.name !== RouteName.SupportAppeals) {
          this.$router.push({ name: RouteName.SupportAppeals })
        }
      },
      // Чат открывается на «Новое обращение» (Q27); пока виджет без чата - форма.
      writeToSupport () {
        this.$store.commit('app/hideProfileDrawer')
        this.$store.commit('support/requestNewAppeal')
      },
    },
  }
</script>

<style scoped lang="less">
@import '../support/tokens.less';

.tech-support {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border-radius: 5px;
  background: @fakt-dark;
}

.tech-support__head {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.tech-support__icon {
  color: @fakt-orange !important;
}

.tech-support__title {
  font-size: 12px;
  font-weight: 500;
  color: @fakt-white;
}

.tech-support__hours {
  margin-top: 2px;
  font-size: 11px;
  color: @fakt-on-dark-muted;
}

.tech-support__appeals {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  min-height: 36px;
  padding: 0 6px 0 10px;
  border-radius: 5px;
  background: rgba(255, 255, 255, .08);
  color: @fakt-white;
  transition: background-color 0.16s ease;

  &:hover {
    background: rgba(255, 255, 255, .14);
  }
}

.tech-support__appeals-label {
  flex: 1;
  font-size: 13px;
  text-align: left;
}

// Все бейджи пользователя розовые (11-acceptance.md)
.tech-support__badge {
  padding: 1px 8px;
  border-radius: 100px;
  font-size: 11px;
  font-weight: 500;
  color: @fakt-white;
  background: @fakt-pink;
}

.tech-support__chevron {
  color: @fakt-on-dark-muted !important;
}

.tech-support__write {
  font-size: 13px;
  color: @fakt-white !important;
  background-color: @fakt-orange !important;
}
</style>
